// Tracks the ONE background patient generation the user may have walked away
// from (Karar 40). The create-patient page writes an entry when it kicks the
// job off; PendingGenerationWatcher polls it and pops a "your patient is ready"
// toast. Same plain-localStorage pattern as pendingEval, and on purpose: no
// global store, survives navigation and reloads.

export type PendingGeneration = {
  startedAt: number;
  // The name the student asked for (may be empty — the renderer invents one).
  requestedName?: string | null;
  // Set once the case has landed but the toast hasn't been acknowledged yet,
  // so navigating re-opens on "hazır" instead of flashing "üretiliyor".
  ready?: boolean;
  caseName?: string | null;
};

const KEY = "pp_pending_generation";
// Aynı sekmedeki yazım/silme duyurusu (F5), pendingEval ile aynı gerekçe.
export const PENDING_GENERATION_EVENT = "pp:pending-generation";

function announce(): void {
  if (typeof window !== "undefined") window.dispatchEvent(new Event(PENDING_GENERATION_EVENT));
}

export function setPendingGeneration(entry: PendingGeneration): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(entry));
  } catch {
    /* storage unavailable (private mode); the dashboard still shows the case */
  }
  announce();
}

export function getPendingGeneration(): PendingGeneration | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed?.startedAt !== "number") return null;
    return parsed as PendingGeneration;
  } catch {
    return null;
  }
}

export function clearPendingGeneration(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  announce();
}
